/* ========================================
AnnouncementCarousel
======================================== */
class AnnouncementCarousel extends HTMLElement {
    constructor() {
        super();
        this.currentSlide = 0;
        this.slides = [];
        this.intervalId = null;
        // 👇 TEMPO ENTRE UMA MENSAGEM E OUTRA (em milissegundos)
        this.autoplayDelay = 5000; // 5000 = 5 segundos
    }

    connectedCallback() {
        // Wait for children to be rendered
        setTimeout(() => {
            this.init();
        }, 0);
    }

    init() {
        this.slides = Array.from(this.querySelectorAll('.announcement-slide'));

        if (this.slides.length <= 1) {
            // Nada a fazer se houver 0 ou 1 slide
            return;
        }

        this.startAutoplay();
    }

    disconnectedCallback() {
        this.stopAutoplay();
    }

    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.updateSlides();
    }

    updateSlides() {
        this.slides.forEach((slide, index) => {
            slide.classList.toggle('active', index === this.currentSlide);
        });
    }

    startAutoplay() {
        if (this.slides.length <= 1) return;

        this.stopAutoplay();
        this.intervalId = setInterval(() => {
            this.nextSlide();
        }, this.autoplayDelay);
    }

    stopAutoplay() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

if (!customElements.get('announcement-carousel')) {
    customElements.define('announcement-carousel', AnnouncementCarousel);
}